var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreeningQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.024,
    height: 40.024,
    viewBox: "0 0 40.024 40.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187500",
    "data-name": "Group 187500",
    transform: "translate(-325 -266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37627",
    "data-name": "Path 37627",
    d: "M10.006,0H30.018A10.006,10.006,0,0,1,40.024,10.006V30.018A10.006,10.006,0,0,1,30.018,40.024H10.006A10.006,10.006,0,0,1,0,30.018V10.006A10.006,10.006,0,0,1,10.006,0Z",
    transform: "translate(325 266)",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_185863",
    "data-name": "Group 185863",
    transform: "translate(258 255.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185864",
    "data-name": "Group 185864",
    transform: "translate(77 21.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17939",
    "data-name": "Path 17939",
    d: "M0,9.925c.061-.432.1-.868.187-1.3a9.544,9.544,0,0,1,2.745-5.1A9.5,9.5,0,0,1,8.441.835a9.582,9.582,0,0,1,6.792,1.594.383.383,0,1,1-.427.629A8.972,8.972,0,0,0,1,8.54a8.8,8.8,0,0,0,1.436,7.171.665.665,0,0,1,.108.621c-.163.56-.306,1.126-.456,1.689-.014.053-.023.106-.041.195l1.031-.274c.294-.079.59-.15.88-.241a.591.591,0,0,1,.568.106,8.5,8.5,0,0,0,2.725,1.32,8.982,8.982,0,0,0,11.313-6.851,8.807,8.807,0,0,0-1.306-6.733c-.028-.043-.057-.084-.083-.128a.384.384,0,0,1,.092-.539.372.372,0,0,1,.543.13,16.86,16.86,0,0,1,.851,1.526,9.557,9.557,0,0,1,.809,4.883,9.75,9.75,0,0,1-8.957,8.805,1,1,0,0,0-.146.032H9.183a.894.894,0,0,0-.129-.028A9.74,9.74,0,0,1,4.228,18.54a.355.355,0,0,0-.257-.042c-.749.192-1.495.395-2.242.592a.859.859,0,0,1-.279.045.374.374,0,0,1-.316-.5q.3-1.14.611-2.276a.415.415,0,0,0-.06-.385A9.452,9.452,0,0,1,.145,12.139C.088,11.8.048,11.451,0,11.106V9.925",
    transform: "translate(0 -0.741)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17941",
    "data-name": "Path 17941",
    d: "M125.47,73.576a3.678,3.678,0,0,1-1.96,3.1,1.153,1.153,0,0,0-.668,1,1.162,1.162,0,0,1-1.285,1.095,1.179,1.179,0,0,1-1.094-1.253,3.2,3.2,0,0,1,1.708-2.825,1.625,1.625,0,0,0,.842-.932,1.447,1.447,0,0,0-.913-1.747,1.4,1.4,0,0,0-1.744.763c-.026.058-.047.118-.071.176a1.2,1.2,0,0,1-2.242-.846,3.791,3.791,0,0,1,6.412-1.311,3.9,3.9,0,0,1,1.014,2.781m-.761-.041a3.116,3.116,0,0,0-3.954-3.106,2.988,2.988,0,0,0-1.99,1.924.431.431,0,0,0,.235.571.441.441,0,0,0,.58-.253c.021-.046.035-.1.054-.142a2.177,2.177,0,0,1,2.626-1.27,2.213,2.213,0,0,1,1.526,2.545,2.286,2.286,0,0,1-1.238,1.551,2.441,2.441,0,0,0-1.323,2.186.435.435,0,1,0,.869.032,1.747,1.747,0,0,1,1.01-1.539,2.936,2.936,0,0,0,1.605-2.5",
    transform: "translate(-111.967 -66.034)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17942",
    "data-name": "Path 17942",
    d: "M168.04,270.651a1.2,1.2,0,0,1-.005-2.4,1.2,1.2,0,1,1,.005,2.4m-.009-.763a.433.433,0,0,0,.444-.425.443.443,0,0,0-.43-.443.434.434,0,0,0-.44.429.425.425,0,0,0,.426.439",
    transform: "translate(-158.349 -254.638)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17943",
    "data-name": "Path 17943",
    d: "M314.736,55.5a.375.375,0,0,1-.373-.377.385.385,0,0,1,.372-.382.39.39,0,0,1,.386.39.384.384,0,0,1-.385.369",
    transform: "translate(-298.36 -51.988)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17944",
    "data-name": "Path 17944",
    d: "M138.866,87.69a2.936,2.936,0,0,1-1.605,2.5,1.747,1.747,0,0,0-1.01,1.539.435.435,0,1,1-.869-.032A2.441,2.441,0,0,1,136.7,89.51a2.286,2.286,0,0,0,1.238-1.551,2.213,2.213,0,0,0-1.526-2.545,2.177,2.177,0,0,0-2.626,1.27c-.019.047-.033.1-.054.142a.441.441,0,0,1-.58.253.431.431,0,0,1-.235-.571,2.988,2.988,0,0,1,1.99-1.924,3.116,3.116,0,0,1,3.954,3.106",
    transform: "translate(-126.124 -80.189)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17945",
    "data-name": "Path 17945",
    d: "M182.247,284.125a.425.425,0,0,1-.426-.439.434.434,0,0,1,.44-.429.443.443,0,0,1,.43.443.433.433,0,0,1-.444.425",
    transform: "translate(-172.565 -268.875)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreeningQuestion);
export default __webpack_public_path__ + "static/media/screening-question.412962838e6f82e2c0aa6dd6d183d093.svg";
export { ForwardRef as ReactComponent };